module.exports = __webpack_public_path__ + "img/up.c9f9423e.svg";